import script from "./GalleryDetailComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryDetailComponent.vue?vue&type=script&setup=true&lang=js"

import "./GalleryDetailComponent.vue?vue&type=style&index=0&id=672afdcc&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-672afdcc"]])

export default __exports__